import { LazyLoadImage } from 'react-lazy-load-image-component';

import CityImageJpg from '../../../assets/about/city-sequence/capitoly_to_web_00001.jpg';
import CityImageWebp from '../../../assets/about/city-sequence/capitoly_to_web_00001.webp';
import landmarkVideoSmall from '../../../assets/about/city-sequence/city-mobile.mp4';
import landmarkVideo from '../../../assets/about/city-sequence/city.mp4';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import ScrollVideo from '../../../components/scrollVideo/ScrollVideo';
import { ScreenSize, useScreenSize } from '../../../hooks/useScreenSize';
import { getWebpSupport } from '../../../utils/get-webp-support.utils';
import AboutTextBox from '../aboutTextBox/AboutTextBox';

import styles from './AboutLandmarksSection.module.scss';

const CityImage = getWebpSupport() ? CityImageWebp : CityImageJpg;

const AboutLandmarksSection = () => {
  const screenSize = useScreenSize();

  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem className={styles['textbox-container']} delay="0.1s">
          <AboutTextBox
            className={styles['textbox']}
            caption={
              <>
                iconic landmarks as <b>nft</b>
              </>
            }
            content={
              <>
                <p>
                  2000 most famous landmarks globally tokenized into 3D NFT. Each of the NFTs represents real-world
                  buildings, cities, and countries. They are made on a 1:1 scale and are 3D assets compatible to use in
                  other games and Metaverses.
                </p>
              </>
            }
          />
        </ScrollInAnimationItem>
      </div>
      <ScrollVideo
        className={styles['scroll-canvas']}
        videoSource={screenSize > ScreenSize.extraSmall ? landmarkVideo : landmarkVideoSmall}
        videoFPS={20}
      />
      <LazyLoadImage className={styles['background-image']} src={CityImage} alt="" />
    </div>
  );
};

export default AboutLandmarksSection;
